import { view } from '@risingstack/react-easy-state'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import PropertyMap from '../../../components/property-map/property-map'
import GenericPageContainer from '../../../GenericPageElements/GenericPageContainer'
import request from '../../../helpers/request'
import endpoints from '../../../helpers/endpoints'
import { CurrentMeter, Summary } from './shared'
import {CMOSLive} from '../../../components/ap-generics/components/evidence-tables/CMOSLive'
import { AddressBase } from '../../../components/ap-generics/components/evidence-tables/AddressBase'
import { ValuationOfficeAndCouncilTax } from '../../../components/ap-generics/components/evidence-tables/ValuationOfficeAndCouncilTax'
import { MeterAddress } from '../../../components/ap-generics/components/evidence-tables/MeterAddress'
import { CMOSFormatted } from '../../../components/ap-generics/components/evidence-tables/CMOSFormatted'
import { MDS } from '../../../components/ap-generics/components/evidence-tables/MDS'
import { ConfirmModal } from '../../../components/ap-generics/components/modals/ConfirmModal.jsx'
import useMDSData from '../../../components/ap-generics/hooks/useMDSData'
import syncRowHeights  from '../../../helpers/syncRowHeights.js'
import LinkedReferenceTable from '../../../components/linked-reference-table/LinkedReferenceTable.jsx'

export default view(function MeterCoordinatesValidationWorkflow() {
  const [summaryData, setSummaryData] = useState({})
  const [selectedMatches, setSelectedMatches] = useState({abp: '', voa: '', ct: ''})
  const [confirmModal, setConfirmModal] = useState(false)
  const [loadingPremises, setLoadingPremises] = useState(false)
  const [premisesData, setPremisesData] = useState({})
  const [addressType, setAddressType] = useState("");
  const [cmosUserInput, setCmosUserInput] = useState({});
  const [meterUserInput, setMeterUserInput] = useState({})
  const [disabledByUserType, setDisabledByUserType] = useState(true)
  const prefix = "METER_COORDINATION_VALIDAITON"
  const [meterOrCmos, setMeterOrCmos] = useState("meter")
  const {mdsData, setMdsData, mdsDataReady, setMdsDataReady, mdsMeterData, setMdsMeterData, customMDSPostcode, setCustomMDSPostcode} = useMDSData(summaryData, prefix)

  const [translations, setTranslations] = useState({})
  useEffect(() => {
    request(true).get('/translate?key=mosl_eligibility')
    .then(e => {
      setTranslations(e.data)
    })
    }, [])
    useEffect(() => {
      setSelectedMatches({abp: '', voa: '', ct: ''})
    }, [summaryData.Core_SPID])
    
  const getMDSData = () => {
    if (!summaryData || !summaryData.Core_SPID) return
    setMdsDataReady(false);
    request(true).get(endpoints.METER_COORDINATION_VALIDAITON_MDS_SPID, {
      doesCancel: true,
      params: {
          postcode: customMDSPostcode || summaryData.CF_Postcode || summaryData.CMOS_Postcode || summaryData.CMOS_Meter_Address_Postcode
      }
    }).then(r => {
      setMdsData(r.data)
      setMdsDataReady(true)
    }).catch(e => {
      setMdsDataReady(true)
        console.log(e);
    })
  }

  useEffect(() => {
    setAddressType(summaryData.CF_Meter_Address_Address_Line_1 ? 'meter' : summaryData.CF_Address_Line_1 ? 'premises' : "")
  }, [summaryData.Meter_ID])

  const getPremisesData = () => {
    setLoadingPremises(true)
    // setUserInput({})
    request(true).get(endpoints.METER_COORDINATION_VALIDAITON_GET_PREMISES, {
      doesCancel: true,
      params: {
        SPID: summaryData.Core_SPID
      }
    }).then(r => {
      setPremisesData(r.data)
      setLoadingPremises(false)
    }).catch(e => {
      console.log(e)
      setLoadingPremises(false)
    })
  }

  useEffect(() => {
    if (summaryData && summaryData.Meter_ID) {
      getPremisesData()
    } else {
      setPremisesData({})
      setLoadingPremises(false)
    }
  }, [summaryData.Meter_ID])

  useEffect(() => {
    syncRowHeights()
  }, [premisesData, mdsData, selectedMatches, meterOrCmos])

  return (
    <GenericPageContainer
      containerWidth={"95vw"}
      title="Meter Coordinates Validation - Workflow"
      titleIconClass={"fak fa-id-business-icon fa-2x colour-primary"}
      titleRight={
        <div>
          <Link className="navigate" to="/portal/meter-coordinates-validation">
              To Summary
          </Link>
          <Link className="navigate" to="/portal/meter-coordinates-validation/search">
              To Search
          </Link>
        </div>
      }
    >
      <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
        <div style={{display: 'grid', gap: 10}}>
          <Summary translations={translations} summaryData={summaryData} setSummaryData={setSummaryData} workflow={true} setMdsData={setMdsData} setMdsDataReady={setMdsDataReady} getMDSData={getMDSData} setConfirmModal={setConfirmModal} userInput={cmosUserInput} setAddressType={setAddressType} disabledByUserType={disabledByUserType} setDisabledByUserType={setDisabledByUserType} prefix={prefix} />
        </div>

        <div style={{display: 'grid', gridAutoColumns: '1fr', gridAutoFlow: 'column', gap: 10}}>
          { meterOrCmos === "meter" ?
            <CurrentMeter translations={translations} summaryData={summaryData} selectedMatches={selectedMatches} setSelectedMatches={setSelectedMatches} premisesData={premisesData} loading={loadingPremises} toggle={() => setMeterOrCmos('cmos')} />
            :
            <CMOSLive translations={translations} summaryData={premisesData} selectedMatches={selectedMatches} setSelectedMatches={setSelectedMatches} prefix={prefix} disabledByUserType={disabledByUserType} toggle={() => setMeterOrCmos('meter')} />
          }
          <AddressBase translations={translations} summaryData={summaryData} selectedMatches={selectedMatches} setSelectedMatches={setSelectedMatches} prefix={prefix} disabledByUserType={disabledByUserType} setUserInput={setCmosUserInput} />
          <ValuationOfficeAndCouncilTax translations={translations} summaryData={summaryData} selectedMatches={selectedMatches} setSelectedMatches={setSelectedMatches} prefix={prefix} disabledByUserType={disabledByUserType} setUserInput={setCmosUserInput} />
          <MeterAddress translations={translations} summaryData={summaryData} selectedMatches={selectedMatches} setSelectedMatches={setSelectedMatches} prefix={prefix} disabledByUserType={disabledByUserType} userInput={meterUserInput} setUserInput={setMeterUserInput} />
          <CMOSFormatted translations={translations} summaryData={summaryData} selectedMatches={selectedMatches} prefix={prefix} disabledByUserType={disabledByUserType} userInput={cmosUserInput} setUserInput={setCmosUserInput} meterInput={meterUserInput} setSummaryData={setSummaryData} />
        </div>
        <div>
          <ConfirmModal confirmModal={confirmModal} setConfirmModal={setConfirmModal} prefix={prefix} summaryData={summaryData} setSummaryData={setSummaryData} cmosUserInput={cmosUserInput} meterUserInput={meterUserInput} />
        </div>
        <LinkedReferenceTable summaryData={summaryData} translations={translations} prefix={prefix} />
        <MDS data={ mdsData } MDSDataReady={ mdsDataReady } getData={ getMDSData } customPostcode={ customMDSPostcode } setCustomPostcode={ setCustomMDSPostcode } style={{ fontSize: '14px' }} classes={"squish"} SPID={summaryData?.Core_SPID} /> 
        <div style={{minHeight: '40vh', marginBottom: '10em'}}>
          <PropertyMap 
            translations={translations} 
            eastingNorthing={summaryData && summaryData.CMOS_UPRN_GISX && summaryData.CMOS_UPRN_GISY && [parseInt(summaryData.CMOS_UPRN_GISX), parseInt(summaryData.CMOS_UPRN_GISY)]} 
            address={summaryData['CMOS_Address_Single_Line'] ?? summaryData['CMOS_Meter_Address_Single_Line']} 
            uprnEastingNorthing={summaryData && summaryData.Matched_UPRN_GISX && summaryData.Matched_UPRN_GISY && [parseInt(summaryData.Matched_UPRN_GISX), parseInt(summaryData.Matched_UPRN_GISY)]} 
            meterEastingNorthing={summaryData && summaryData.CMOS_Meter_GISX && summaryData.CMOS_Meter_GISY  && [parseInt(summaryData.CMOS_Meter_GISX), parseInt(summaryData.CMOS_Meter_GISY )]} 
            displayExtraPins={true} 
            matchedUprnText={true}
          />
        </div>
      </div>
    </GenericPageContainer>    
  )
})
